import type {
    FoodOrderLabel,
} from "./foodTypes";

export function printFoodLabels(
    labels: FoodOrderLabel[]
) {
    if (!labels.length) {
        return;
    }

    const printWindow =
        window.open(
            "",
            "_blank",
            "width=1000,height=750"
        );

    if (!printWindow) {
        alert(
            "Browseren blokerede printvinduet."
        );

        return;
    }

    const labelHtml = labels
        .map(label => {
            if (label.isSplit) {
                return `
                    <section class="label">
                        <div class="label-inner">
                            <div class="top-row">
                                <div class="order-badge">
                                    ORDRE #${label.orderId}
                                </div>

                                <div class="label-count">
                                    ${label.labelNumber} / ${label.labelCount}
                                </div>
                            </div>

                            <div class="main-content">
                                <div class="small-title">
                                    PRODUKT
                                </div>

                                <div class="product-name">
                                    ${escapeHtml(
                    label.productName ?? ""
                )}
                                </div>

                                <div class="person-divider"></div>

                                <div class="small-title">
                                    PERSON
                                </div>

                                <div class="person-name">
                                    ${escapeHtml(
                    label.personName
                )}
                                </div>
                            </div>

                            <div class="footer">
                                PLAYER LOUNGE
                            </div>
                        </div>
                    </section>
                `;
            }

            const lines = label.lines
                .map(
                    line => `
                        <div class="order-line">
                            <span class="qty">
                                ${line.quantity} ×
                            </span>

                            <span>
                                ${escapeHtml(
                        line.name
                    )}
                            </span>
                        </div>
                    `
                )
                .join("");

            return `
                <section class="label">
                    <div class="label-inner">
                        <div class="top-row">
                            <div class="order-badge">
                                ORDRE #${label.orderId}
                            </div>

                            <div class="label-count single">
                                1 / 1
                            </div>
                        </div>

                        <div class="main-content">
                            <div class="small-title">
                                PERSON
                            </div>

                            <div class="person-name person-name-large">
                                ${escapeHtml(
                label.personName
            )}
                            </div>

                            <div class="person-divider"></div>

                            <div class="small-title">
                                ORDRE
                            </div>

                            <div class="order-lines">
                                ${lines}
                            </div>
                        </div>

                        <div class="footer">
                            PLAYER LOUNGE
                        </div>
                    </div>
                </section>
            `;
        })
        .join("");

    printWindow.document.write(`
        <!DOCTYPE html>

        <html>
            <head>
                <meta charset="utf-8" />

                <title>Food labels</title>

                <style>
                    /*
                     * Din label er fysisk:
                     * 101,6 mm × 152,4 mm
                     *
                     * Vi printer den liggende:
                     * 152,4 mm × 101,6 mm
                     */
                    @page {
                        size: 152.4mm 101.6mm;
                        margin: 0;
                    }

                    * {
                        box-sizing: border-box;
                    }

                    html,
                    body {
                        margin: 0;
                        padding: 0;

                        width: 100%;
                        height: 100%;

                        font-family:
                            Arial,
                            Helvetica,
                            sans-serif;

                        background: #ffffff;
                        color: #000000;
                    }

                    .label {
                        width: 152.4mm;
                        height: 101.6mm;

                        margin: 0;
                        padding: 0;

                        position: relative;

                        overflow: hidden;

                        page-break-after: always;
                        break-after: page;
                    }

                    .label:last-child {
                        page-break-after: auto;
                        break-after: auto;
                    }

                    /*
                     * Labelen skal sidde omvendt fysisk.
                     * Derfor roteres hele indholdet 180 grader.
                     */
                    .label-inner {
                        width: 152.4mm;
                        height: 101.6mm;

                        padding: 7mm 8mm 6mm 8mm;

                        display: flex;
                        flex-direction: column;

                    }

                    .top-row {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;

                        gap: 5mm;
                    }

                    .order-badge {
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;

                        min-height: 14mm;

                        padding: 2.5mm 6mm;

                        background: #000000;
                        color: #ffffff;

                        border-radius: 2.5mm;

                        font-size: 26px;
                        line-height: 1;
                        font-weight: 900;

                        letter-spacing: 0.5px;
                    }

                    .label-count {
                        min-width: 30mm;

                        padding: 2mm 4mm;

                        border: 1.2mm solid #000000;
                        border-radius: 2.5mm;

                        text-align: center;

                        font-size: 25px;
                        font-weight: 900;
                        line-height: 1.1;
                    }

                    .label-count.single {
                        opacity: 0.45;
                    }

                    .main-content {
                        flex: 1;

                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;

                        text-align: center;

                        padding: 4mm 3mm 2mm 3mm;
                    }

                    .small-title {
                        margin-bottom: 1.5mm;

                        font-size: 13px;
                        font-weight: 900;

                        letter-spacing: 2px;

                        color: #555555;
                    }

                    .product-name {
                        max-width: 132mm;

                        font-size: 42px;
                        line-height: 1.02;
                        font-weight: 900;

                        text-transform: uppercase;

                        overflow-wrap: anywhere;
                    }

                    .person-divider {
                        width: 65mm;

                        margin: 4mm 0;

                        border-top: 1mm solid #000000;
                    }

                    .person-name {
                        max-width: 132mm;

                        font-size: 29px;
                        line-height: 1.05;
                        font-weight: 800;

                        overflow-wrap: anywhere;
                    }

                    .person-name-large {
                        font-size: 34px;
                    }

                    .order-lines {
                        width: 100%;
                        max-width: 125mm;

                        display: flex;
                        flex-direction: column;

                        gap: 2mm;
                    }

                    .order-line {
                        display: flex;
                        align-items: baseline;
                        justify-content: center;

                        gap: 3mm;

                        font-size: 25px;
                        line-height: 1.1;
                        font-weight: 800;
                    }

                    .qty {
                        font-weight: 900;
                    }

                    .footer {
                        text-align: center;

                        font-size: 11px;
                        line-height: 1;
                        font-weight: 900;

                        letter-spacing: 3px;

                        color: #777777;
                    }

                    @media print {
                        html,
                        body {
                            width: 152.4mm;
                            height: 101.6mm;
                        }
                    }
                </style>
            </head>

            <body>
                ${labelHtml}
            </body>
        </html>
    `);

    printWindow.document.close();

    printWindow.focus();

    printWindow.onafterprint = () => {
        printWindow.close();
    };

    window.setTimeout(() => {
        printWindow.print();

        // Fallback hvis afterprint ikke bliver fired korrekt
        // i kiosk-printing.
        window.setTimeout(() => {
            if (!printWindow.closed) {
                printWindow.close();
            }
        }, 1500);
    }, 350);
}

function escapeHtml(
    value: string
) {
    return value
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}